export const SET_WALLET_LOADING = 'SET_WALLET_LOADING';
export const SET_WALLET_TRANSACTIONS = 'SET_WALLET_TRANSACTIONS';
export const SET_WALLET_LAST_TRANSACTION = 'SET_WALLET_LAST_TRANSACTION';
export const SET_WALLET_BALANCE = 'SET_WALLET_BALANCE';
export const SET_WALLET_EXCHANGE_RATE = 'SET_WALLET_EXCHANGE_RATE';
export const SET_WALLET_WITHDRAWAL_LIMIT = 'SET_WALLET_WITHDRAWAL_LIMITS';
export const SET_WALLET_COREFY_PAYOUT_LIMIT = 'SET_WALLET_COREFY_PAYOUT_LIMIT'
